export default __webpack_public_path__ + "b6dfb0fd747fa0b6873e689aacdfc70d.png";